import React, {FunctionComponent, useState} from "react";
import { FormControl, FormHelperText, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';

type ChallengeLocationSelectProps = {
    locations: string[],
    locationDescription?: string,
    initialValue?: string,
}

export const ChallengeLocationSelect: FunctionComponent<ChallengeLocationSelectProps> = ({
                                                                                             locationDescription,
                                                                                             locations,
                                                                                             initialValue
                                                                                         }) => {

    const initialIndex = !Boolean(initialValue)
        ? 0
        : locations.findIndex(l => l === initialValue);

    const [location, setLocation] = useState(locations[initialIndex]);
    const classes = useStyles();

    if (locations.length === 0) return null;

    const handleChange = (event: SelectChangeEvent) => {
        setLocation(event.target.value as string);
    }


    return (
        <FormControl className={classes.select}>
            <Select
                id="locations-select"
                name="grp"
                value={location}
                onChange={handleChange}
            >
                {locations.map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
            </Select>
            {locationDescription &&
            <FormHelperText className={classes.helperText}>{locationDescription}</FormHelperText>}
        </FormControl>
    );
}

const useStyles = makeStyles({
    select: {
        width: "100%",
        maxWidth: "30rem",
        marginTop: "1rem"
    },
    helperText: {
        color: "#000"
    }
})